<template>
  <div class="routDetail-wrap"
    v-watermark="{ text: watermarkText() }"
    v-loading="dataLoading"
    element-loading-text="正在载入，请稍候……"
    element-loading-spinner="el-icon-loading"
    element-loading-background="#fff">
    <div id="pdfDom" ref="pdfDom" class="pdfDom">
      <div class="header-wrapper">
        <div class="header-title">
          <div class="header-title-top">{{ taskData.assessName }}</div>
          <div class="header-title-bottom">
            <div>{{ taskData.storeName }}</div>
            <div class="right">
              <div>
                评估人：{{ taskData.finishUserName }}
                {{ taskData.finishTime | getDate }}
              </div>
              <div class="split-line" v-if="hasSign || executable"></div>
              <el-popover ref="sign_pop"
                placement="left"
                :width="315"
                :trigger="executable ? 'click' : 'hover'"
                @hide="showSign = true"
                v-if="hasSign || executable">
                <template v-if="showSign && hasSign">
                  <div class="sign-img">
                    <img :src="taskData.signSource || taskData.signUrl" alt=""/>
                    <el-button v-if="executable" size="small" round @click="showSign = false">重新签字</el-button>
                  </div>
                </template>
                <template v-else>
                  <VueEsign ref="esign" :width="315" :height="560"/>
                  <div class="rflex jcsa">
                    <el-button size="small" round @click="_esignReset">清空画板</el-button>
                    <el-button size="small" type="primary" round @click="_esignSave">保存签字</el-button>
                    <div style="display: none;"></div>
                  </div>
                </template>
                <div class="look-sign" slot="reference">
                  <img src="../images/edit备份 3@2x.png" alt=""/>
                  <div :style="{cursor: executable ? 'pointer' : ''}">{{ `${hasSign ? '查看' : '去'}签字` }}</div>
                </div>
              </el-popover>
            </div>
          </div>
        </div>
        <div class="header-panel">
          <div class="panel-item" v-if="taskData.assessScoreType != 1">
            <img src="../images/totalScore.png" alt=""/>
            <div class="right">
              <div class="score">总得分</div>
              <div class="quantity">{{ taskData.score }}<span
                v-if="taskData.scoreLevelName">({{ taskData.scoreLevelName }})</span>
              </div>
            </div>
          </div>
          <div class="panel-item" v-if="taskData.defaultMajorScoringRate">
            <img src="../images/losePointNum.png" alt=""/>
            <div class="right">
              <div class="score">{{ taskData.defaultMajorScoringRate.name }}</div>
              <div class="quantity">{{ taskData.defaultMajorScoringRate.scoringRate.toFixed(1)+'%' }}</div>
            </div>
          </div>          
          <div class="panel-item">
            <img src="../images/losePointNum.png" alt=""/>
            <div class="right">
              <div class="score">失分项</div>
              <div class="quantity">{{ taskData.losePointNum }}</div>
            </div>
          </div>
          <div class="panel-item">
            <img src="../images/correctNum.png" alt=""/>
            <div class="right">
              <div class="score">整改项</div>
              <div class="quantity">{{ taskData.correctNum }}</div>
            </div>
          </div>
        </div>
        
        <div v-if="taskData.showMajorScoringRate && Array.isArray(taskData.taskGroupModels)" class="">
          <div v-for="group in taskData.taskGroupModels" :key="group.id" class="rflex">
            <div class="rectangle wflex1 cflex jcc">
              <span>{{ group.name }}</span>
            </div>
            <div class="rectangle wflex1 cflex jcc text_center">
              <span>{{ _getScoreRate(group.fullScore, group.score) }}</span>
            </div>
            <div v-if="Array.isArray(group.childTaskGroupDtos) && group.childTaskGroupDtos.length" class="wflex2">
              <div v-for="cg in group.childTaskGroupDtos" :key="cg.id" class="rflex">
                <div class="rectangle wflex1 cflex jcc">
                  <span>{{ cg.name }}</span>
                </div>
                <div class="rectangle wflex1 cflex jcc text_center">
                  <span>{{ _getScoreRate(cg.fullScore, cg.score) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>      

      </div>
      <div v-if="recordId" class="select">
        <div class="select-right">
          <el-select
            v-model="showType"
            style="width: 118px"
            @change="selectChange">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="record">共{{ taskData.taskItemCount }}条记录</div>
        </div>
        <el-button v-if="executable" @click="_submit">提交</el-button>
        <el-button v-else @click="pdfDownload">导出</el-button>
      </div>
      <div
        v-for="group in taskData.taskGroupModels"
        :key="group.id"
        class="groupWrapper">
        <div class="groupName item">{{ group.name }}</div>
        <div
          v-for="subGroup in group.childTaskGroupDtos"
          :key="subGroup.id"
          class="subGroupWrapper">
          <div class="subGroupName item">
            <div class="circular"></div>
            {{ subGroup.name }}
          </div>
          <TirList v-if="Array.isArray(subGroup.assessItem)" :tirList="subGroup.assessItem" :showCheckBoxOptions="taskData.multipleOptionsDisplay===1"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getFindTaskDetailById,
  sharedReport,
  exportTaskDetailPDF,
  exportSharedReportPDF,
  execTaskItemH5
} from "../../../api/request.js";
import { getDate, getScoreRate } from "../../../libs/tools";
import { successMsg, failureMsg } from '../../../utils/message';
import { traverseFromBottom, traverseEmi, isTrueOfMi, checkSubmit, CheckItems } from '../../executeTasks/tools';
import VueEsign from 'vue-esign'
import TirList from './components/TirList.vue'
import { exportExcel } from "../../../utils/export.js";
import "../../../utils/watermark";

export default {
  data() {
    return {
      taskData: {},
      miData: {
        allItemCount: 0,
        allMiList: [],
        loseItemCount: 0,
        loseMiList: []
      },
      dataLoading: false,
      showPre: true,
      showType: this.reportShowType, //el-select绑定
      options: [
        {
          value: 1,
          label: "全部",
        },
        {
          value: 2,
          label: "失分项",
        },
      ],
      testIcon: require("../../../assets/image/evaAnlus/one.png"),
      showSign: true,
      itemList: []
    };
  },
  components: {
    VueEsign,
    TirList
  },
  props: ["recordId", "reportShowType", "tenant", "corLimit", "refresh"],
  mounted() {
    this._loadData(this.reportShowType);
  },
  watch: {
    recordId() {
      this.showType = this.reportShowType;
      this._loadData(this.reportShowType);
    },
    refresh() {
      this.refresh && this._loadData(this.showType);
    }
  },
  computed: {
    executable() {
      return Number.isInteger(this.corLimit);
    },
    hasSign() {
      return this.taskData.signSource || this.taskData.signSource;
    }
  },
  filters: {
    getDate(val) {
      return getDate(val);
    },
  },
  methods: {
    _loadData(reportShowType) {
      this.taskData = {};
      this.itemList.splice(0, this.itemList.length);
      this.miData.allMiList.splice(0, this.miData.allMiList.length);
      this.miData.loseMiList.splice(0, this.miData.loseMiList.length);
      if (this.recordId) {
        this.dataLoading = true;
        (this.tenant ? 
          sharedReport(
            {
              tenant: this.tenant,
              taskRecordId: this.recordId
            },
            { reportShowType }
          ) : 
          getFindTaskDetailById({
            recordId: this.recordId,
            reportShowType: this.executable ? 1 : reportShowType
          })
        ).then((res) => {
          if (res && res.data) {
            if (res.data.score)
              res.data.score = parseFloat(res.data.score).toFixed(2);
            if (this.executable) {
              traverseEmi(res.data.taskGroupModels, this.pushItemList, this);
              this.miData.allItemCount = res.data.taskItemCount;
              this.miData.loseItemCount = this.itemList.filter(ai => ai.losePoint).length;
              if (Array.isArray(res.data.taskGroupModels)) {
                res.data.taskGroupModels.forEach(mi => {
                  this.miData.allMiList.push(JSON.parse(JSON.stringify(mi)));
                  isTrueOfMi(mi, this.hasLoseItem) && this.miData.loseMiList.push(mi);
                });
                traverseFromBottom(this.miData.loseMiList, this.deleteNoneLose);
              }
              if (reportShowType === 2) {
                res.data.taskItemCount = this.miData.loseItemCount;
                res.data.taskGroupModels = this.miData.loseMiList;
              }
            }
            this.taskData = res.data;
          }
        }).finally(() => this.dataLoading = false);
      }
    },
    pushItemList(mi) {
      Array.isArray(mi.assessItem) && mi.assessItem.forEach(ai => this.itemList.push(ai));
    },
    hasLoseItem(mi) {
      return Array.isArray(mi.assessItem) && mi.assessItem.some(ai => ai.losePoint);
    },
    deleteNoneLose(mi) {
      if (mi.isEndGroup === 1) {
        if (this.hasLoseItem(mi)) {
          mi.assessItem.reduceRight((acc,ai,i,array) => {
            !ai.losePoint && array.splice(i,1);
          },[])
        } else {
          mi.del = true
        }
      } else if (Array.isArray(mi.childTaskGroupDtos)) {
        mi.childTaskGroupDtos.reduceRight((acc,cmi,i,array) => cmi.del && array.splice(i,1), []);
        if (!mi.childTaskGroupDtos.length) mi.del = true;
      }
    },    
    _submit() {
      const cr = checkSubmit(this.taskData, this.itemList);
      if (cr.showRemind) {
        const h = this.$createElement;
        const checkList = [];
        cr.checkItems.forEach((ci,i) => {
          ci.result && checkList.push(
            h('li', {
                class: 'submit-check-item',
                on: { click: this._handleCheckClick }
              }, CheckItems[i].text + ci.text)
          )
        })
        this.$msgbox({
          title: '有未完成的部分',
          message: h('ul', { class: 'submit-check-box', key: new Date().getTime() }, checkList),
          showConfirmButton: cr.canSubmit,
          showCancelButton: true,
          distinguishCancelAndClose: true,
          confirmButtonText: '跳过并提交',
          cancelButtonText: '继续评估',
          center: true,
          roundButton: true,
          callback: action => {
            if (action === 'confirm') {
              this._submitTask();
            } else if (action === 'cancel') {
              this.$emit('previewClose', 0);
            }
          }
        });
      } else {
        this._submitTask();
      }
    },
    _handleCheckClick(e) {
      this.$msgbox.close();
      if (e.target.innerText.includes(CheckItems[0].text)) {
        setTimeout(this.$refs.sign_pop.doShow, 100)
      } else {
        for (let i=1; i<CheckItems.length; i++) {
          if (e.target.innerText.includes(CheckItems[i].text)) {
            this.$emit('previewClose', i);
            break;
          }
        }
      }
    },
    _submitTask() {
      this.$emit('previewClose', -1);
    },
    _esignReset() {
      this.$refs.esign.reset();
    },
    async _esignSave() {
      const loading = this.$loading();
      try {
        let signSource = await this.$refs.esign.generate();
        if (signSource) {
          let res = await execTaskItemH5(this.recordId,[],signSource);
          if (res.success) {
            successMsg('签字保存成功');
            this.$set(this.taskData, "signSource", signSource);
            this.showSign = true;
          }
        }
      } catch (err) {
        typeof err === "string" && failureMsg(err);
      }
      loading.close();
    },
    pdfDownload() {
      const loading = this.$loading({
        spinner: 'el-icon-loading',
        text: '导出的pdf文件也许会很大，请耐心等待！！！'
      });
      (this.tenant ? 
      exportSharedReportPDF(this.tenant, this.taskData.taskRecordId, this.showType) :
      exportTaskDetailPDF(this.taskData.taskRecordId, this.showType))
      .then(res => {
        exportExcel(res);
      })
      .finally(() => loading.close());
    },
    randomString(len) {
      len = len || 32;
      let $chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      let maxPos = $chars.length;
      let pwd = "";
      for (i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    watermarkText() {
      if (this.executable) return '';
      let name = "";
      let account = "";
      let userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
      if (userInfo) {
        if (userInfo.name) {
          name = userInfo.name;
        }
        if (userInfo.account) {
          account = userInfo.account.length > 4
              ? userInfo.account.slice(-4)
              : userInfo.account;
        }
      }
      return `${name}${account}`;
    },
    selectChange() {
      if (this.executable) {
        if (this.showType == 2) {
          this.taskData.taskItemCount = this.miData.loseItemCount;
          this.taskData.taskGroupModels = this.miData.loseMiList;
        } else {
          this.taskData.taskItemCount = this.miData.allItemCount;
          this.taskData.taskGroupModels = this.miData.allMiList;          
        }
      } else {
        this._loadData(this.showType);
      }
    },
    _getScoreRate(fullScore, score) {
      return getScoreRate(fullScore, score);
    }
  }
};
</script>
<style lang="less" scoped>
.routDetail-wrap {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #182c4e;
  .pdfDom {
    // background-color: red;
    padding: 60px 30px 30px 30px;
  }
  .storeName {
    font-weight: 800;
  }
  .groupWrapper {
    margin-bottom: 20px;
    background-color: #f9f9f9;
    border-radius: 2px;
    overflow: hidden;
    .groupName {
      // font-size: 28px;
      height: 48px;
      line-height: 48px;
      padding-left: 16px;
      background: #f8faff;
      box-shadow: 0px 1px 0px 0px #edeff5;
      font-weight: 500;
    }
    .subGroupWrapper {
      background-color: #fff;
      box-shadow: 0px 1px 1px 0px #edeff5;
    }
    .subGroupName {
      // font-size: 28px;
      height: 44px;
      line-height: 44px;
      background: #f8faff;
      box-shadow: 0px 1px 0px 0px #ffffff;
      font-weight: 500;
      display: flex;
      align-items: center;
      padding-left: 16px;

      .circular {
        width: 8px;
        height: 8px;
        border: 4px solid #428ff8;
        border-radius: 50%;
        margin-right: 8px;
      }
    }
  }

  .header-wrapper {
    border-radius: 2px;
    overflow: hidden;
    // margin-top: 16px;
    margin-bottom: 17px;
    .header-title {
      background: #f8faff;
      padding: 16px 22px;
      // .header-title-top {
      //   font-size: 32px;
      // }
      .header-title-bottom {
        margin-top: 4px;
        font-size: 12px;
        // font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3a4962;
        display: flex;
        justify-content: space-between;
        .right {
          display: flex;
          .look-sign {
            display: flex;
            img {
              margin-right: 4px;
              width: 16px;
              height: 16px;
            }
          }
          .split-line {
            width: 1px;
            height: 16px;
            background: #eae5e5;
            margin: 0 16px;
          }
        }
      }
      .header {
        margin-top: 10px;
        color: #74879b;
      }
    }
    .header-panel {
      background-color: #fff;
      height: 86px;
      display: flex;
      justify-content: space-between;
      margin: 0 20px;
      .panel-item {
        //flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        //margin-left: 40px;
        .right {
          .score {
            font-size: 12px;
            // font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #3a4962;
          }
          .quantity {
            // font-size: 22px;
            font-size: 22px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #182c4e;
          }
        }
        img {
          margin-right: 10px;
          width: 48px;
          height: 48px;
          // width: 60px;
          // height: 60px;
        }
      }
    }
  }

  .select {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .select-right {
      display: flex;
      align-items: center;

      .record {
        // font-size: 24px;
        margin-left: 8px;
      }
    }
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sign-img {
  // height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    max-width: 270px;
    max-height: 480px;
    // width: 250px;
    // height: 140px;
  }
}

.submit-check-box {
  font-size: .9rem;
  .submit-check-item {
    line-height: 2.5em;
    border-bottom: 1px solid;
    border-image: linear-gradient(to right, transparent, rgba(96,98,102,.5), transparent) 1;
  }
}
</style>